import {
  Box,
  CircularProgress,
  FormControl,
  Grid
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useLocation, useNavigate } from 'react-router-dom';
import validator from 'validator';
import LoginImage from '../../../Assets/turboBanner.png';
import Logo from '../../../Assets/Images/turbostart_logo_white.png';
import MobileLoginBG from '../../../Assets/Svg/login-mobile-bg.svg';
import KenButton from '../../../Components/KenButton';
import KenInput from '../../../Components/KenInput';
import KenPhoneInput from '../../../Components/KenPhoneInput/KenPhoneInput2';
import routes from '../../../Constants/routes';
import getValidation from '../../../Utils/Helpers/validationHelper';
import { getSendOTPWithoutContact } from '../../../Utils/apiServices';
import { AccountLink, SubTitle, Title } from '../common';

const useStyles = makeStyles((theme) => ({
  customDatePicker: {
    '& .react-date-picker__calendar': {
      zIndex: 2,
    },
    '& .react-date-picker__wrapper': {
      border: 0,
      borderRadius: '4px',
      padding: '6px 16px',
      backgroundColor: '#F3F5F7',
      textAlign: 'left',
      '&:focus': {
        backgroundColor: theme.palette.KenColors.kenWhite,
      },
      '& input': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__inputGroup__divider': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__button': {
        paddingRight: 0,
      },
    },
  },
  // paper: {
  //   position: "absolute",
  //   width: 500,
  //   minHeight: "520px",
  //   maxHeight: "520px",
  //   overflowY: "auto",
  //   backgroundColor: theme.palette.background.paper,
  //   boxShadow:
  //     "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  //   padding: "48px 84px 32px",
  //   borderRadius: "16px"
  // },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    // textAlign: 'center',
    // backgroundImage: `url(${LoginBG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
    },
    [theme.breakpoints.up('sm')]: {
      height: '100%',
    },

    '& form': {
      top: () => (1 / window.devicePixelRatio === 1 ? '50%' : 0),
      transform: () =>
        1 / window.devicePixelRatio === 1 ? 'translateY(-50%)' : 0,
      position: () => (1 / window.devicePixelRatio === 1 ? 'relative' : 0),
    },
  },
  loginContent: {
    // boxShadow:
    //   '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    // borderRadius: '16px',
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
    },
    '& .scrollbar-container': {
      maxWidth: '500px',
      minHeight: '520px',
      padding: '48px 84px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '16px',
        paddingRight: '16px',
        maxWidth: '360px',
      },
      [theme.breakpoints.up('sm')]: {
        maxHeight: '850px',
        overflowY: 'auto',
      },
    },
  },
  title: {
    margin: () =>
      1 / window.devicePixelRatio !== 1 ? '0 auto 16px auto' : '0 0 16px 0',
  },
  subTitle: {
    margin: () =>
      1 / window.devicePixelRatio !== 1 ? '0 auto 32px auto' : '0 0 32px 0',
  },
  inputFieldLabel: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '100%',
    textTransform: 'capitalize',
    color: theme.palette.KenColors.grey2,
  },
  verify: {
    width: '100%',
    height: '48px',
    marginBottom: '40px',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: '#092682',
    fontFamily: 'Poppins,sans-serif',
  },
  signupWith: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '100%',
    color: theme.palette.KenColors.neutral100,
  },
  signupWithItem: {
    margin: '0 8px',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    boxShadow:
      '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    '& img': {
      height: '24px',
      width: '24px',
    },
  },
  phoneContainer: {
    display: 'flex',
    '& .phone-input': {
      fontFamily: 'Poppins,sans-serif',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '100%',
      border: '1px solid #F5F7F8',

      // color: '#505F79',
      padding: '16px',
      order: 2,
      // background: '#F3F5F7',
      // border: 0,
      height: '48px',
      //   57
      borderRadius: '4px',
      marginLeft: '11px',
      '&::placeholder': {
        fontSize: '16px',
        lineHeight: '100%',
        // color: '#A8AFBC',
        border: '1px solid #F5F7F8',

        fontFamily: 'Poppins,sans-serif',
      },
    },
    '& .phone-dropdown': {
      position: 'relative',
      order: 1,
      // border: 0,
      border: '1px solid #F5F7F8',

      // background: '#F3F5F7',
      '&.open': {
        // background: '#F3F5F7',
        '& .selected-flag': {
          // background: '#F3F5F7',
        },
      },
      '& .selected-flag': {
        width: '50px',
        padding: '10px',
        background: '#FFFFFF',
        border: '1px solid #F5F7F8',
        '&:hover': {
          // background: '#F3F5F7',
        },
      },
    },
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'flex-end',
    height: '100%',
    width: '50%',
    paddingBottom: 24,
    // paddingRight: '20%',
    backgroundImage: `url(${LoginImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${MobileLoginBG})`,
      display: 'none',
    },
    borderRadius: '0px 20px 20px 0px',
    // [theme.breakpoints.only('sm')]: {
    //   backgroundImage: `url(${MobileLoginBG})`,
    //   display: 'none',
    // },
  },
  heading: {
    fontSize: 48,
    fontWeight: 700,
    color: theme.palette.KenColors.kenWhite,
    paddingLeft: '24px',
    // position: 'absolute',
    // bottom: '15%',
    textTransform: 'capitalize',
    textAlign: 'left',
    // left: '1%',
    width: '96%',
  },
  subHeading: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.palette.KenColors.kenWhite,
    // position: 'absolute',
    // bottom: '4%',
    // left: '1%',
    paddingLeft: 24,
    textAlign: 'left',
    width: '95%',
  },
  circularProgress: {
    position: 'absolute',
    top: '54%',
    left: '75%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('sm')]: {
      top: '50%',
      left: '49%',
    },
  },
  logo: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '-40px',
    height: '90px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const email = (value) => {
  if (validator.isEmail(value)) {
    return true;
  }

  return 'Please enter valid email';
};
const phoneValidator = (value) => {
  if (validator.isMobilePhone(value, 'en-IN', { strictMode: true })) {
    return true;
  }

  return 'Please enter valid phone';
};
const dateValidator = (value) => validator.isDate(value);

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  // const [date, onDateChange] = useState(null);
  // const [program, setProgram] = useState(null);
  // const [modalStyle] = React.useState(getModalStyle);
  // const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const query = new URLSearchParams(useLocation().search);
  const prog = query.get('prog');

  const { control, handleSubmit, setValue, trigger } = useForm({
    defaultValues: {
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      phone: '',
      // date: null,
      // program: "",
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // const res = await signUp(data);

      // if (!res || !res?.success) {
      //   return enqueueSnackbar(res?.errorMessage || 'Something went wrong', {
      //     variant: 'error',
      //   });
      // }

      // if (!res?.success) {
      //   if (res.errorMessage) {
      //     alert(res?.errorMessage || 'Something went wrong');
      //   }
      // }

      // TODO: Change it back to verifyLogin and id to phone
      const res = await getSendOTPWithoutContact(
        data?.email,
        data?.phone,
        data?.firstName + ' ' + data?.lastName
      );

      if (res && res?.success) {
        enqueueSnackbar('The OTP has been sent to your Email Id', {
          variant: 'success',
        });
      }

      if (!res?.success) {
        if (res?.errorMessage) {
          alert(
            res?.errorMessage
              ? Array.isArray(res?.errorMessage) &&
                  res?.errorMessage[0]?.errorMessage
              : res?.errorMessage || 'Something went wrong'
          );
        }
      }

      navigate(routes.verifyEmail, {
        state: {
          email: data.email,
          phone: data.phone,
          data: data,
          prog: prog ? prog : '',
        },
      });
    } catch (error) {
      return enqueueSnackbar(
        error && error?.response?.data
          ? Array.isArray(error?.response?.data?.errorMessages) &&
              error?.response?.data?.errorMessages[0]?.errorMessage
          : error?.response?.data?.errorMessage || 'Something went wrong',
        {
          variant: 'error',
        }
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  // const handleDateChange = date => {
  //   setSelectedDate(date);
  // };

  // const body = (
  //   <div style={modalStyle} className={classes.paper}>
  //     {/* Modal */}
  //   </div>
  // );

  return (
    <>
      <Grid container direction="row" style={{ height: '100%', width: '100%' }}>
        <Grid
          container
          item
          xs={12}
          md={6}
          className={classes.imageContainer}
        ></Grid>
        <Grid item xs={12} md={6}>
          <Box className={classes.container}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box className={classes.loginContent}>
                <img
                  src={Logo}
                  onClick={() => {
                    window.open('https://www.turbostart.co/', '_self');
                  }}
                  className={classes.logo}
                />
                <PerfectScrollbar>
                  <Title className={classes.title} text="Get Started!" />
                  <SubTitle
                    className={classes.subTitle}
                    text="Sign up to start your application."
                  />
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="firstName"
                      control={control}
                      rules={{
                        required: 'This field is Required',
                        maxLength: {
                          value: 40,
                          message:
                            'This field cannot be more than 40 characters',
                        },
                        pattern: {
                          message: 'Please input a correct value',
                          value: getValidation('alpha'),
                        },
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenInput
                            required
                            name="firstName"
                            label="First Name"
                            placeholder="Enter First Name"
                            labelClassName={classes.inputFieldLabel}
                            inputType="circular"
                            hideLabel="true"
                            // errorLabel={true}
                            {...field}
                            error={error?.message}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  {/* <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="middleName"
                      control={control}
                      rule={{
                        maxLength: {
                          value: 40,
                          message:
                            'This field cannot be more than 40 characters',
                        },
                        pattern: {
                          message: 'Please input a correct value',
                          value: getValidation('alpha'),
                        },
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenInput
                            name="middleName"
                            label="Middle Name"
                            placeholder="Enter Middle Name"
                            labelClassName={classes.inputFieldLabel}
                            // errorLabel={true}
                            inputType="circular"
                            hideLabel="true"
                            {...field}
                            error={error}
                          />
                        );
                      }}
                    />
                  </FormControl> */}
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="lastName"
                      control={control}
                      rules={{
                        required: 'This field is Required',
                        maxLength: {
                          value: 40,
                          message:
                            'This field cannot be more than 40 characters',
                        },
                        pattern: {
                          message: 'Please input a correct value',
                          value: getValidation('alpha'),
                        },
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenInput
                            required
                            name="lastName"
                            label="Last Name"
                            placeholder="Enter Last Name"
                            inputType="circular"
                            hideLabel="true"
                            labelClassName={classes.inputFieldLabel}
                            // errorLabel={true}
                            {...field}
                            error={error?.message}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: 'This field is Required',
                        validate: email,
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenInput
                            required
                            name="email"
                            label="Email"
                            placeholder="Enter Email"
                            labelClassName={classes.inputFieldLabel}
                            inputType="circular"
                            hideLabel="true"
                            // errorLabel={true}
                            helperText={
                              'This will be used for all future communications'
                            }
                            {...field}
                            error={error?.message}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="phone"
                      control={control}
                      // rules={{ required: true, validate: phoneValidator }}
                      rules={{
                        required: 'This field is Required',
                        minLength: {
                          value: 7,
                          message: 'Please input phone number',
                        },
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenPhoneInput
                            name="phone"
                            containerClass={classes.phoneContainer}
                            inputClass={`${classes.inputFieldLabel} phone-input`}
                            buttonClass="phone-dropdown"
                            country={'in'}
                            placeholder="Enter Number"
                            inputType="circular"
                            hideLabel="true"
                            errorLabel={true}
                            {...field}
                            error={error?.message}
                            onChange={(phone) => {
                              setValue('phone', phone);
                              trigger('phone');
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  {/* <FormControl fullWidth style={{ marginBottom: "24px" }}>
                <Controller
                  name="date"
                  control={control}
                  rules={{ required: true, validate: dateValidator }}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <>
                        <KenTextLabel
                          label="Academic Calendar"
                          labelClassName={classes.inputFieldLabel}
                          required={true}
                        />
                        <DatePicker
                          name="date"
                          className={classes.customDatePicker}
                          clearIcon={null}
                          {...field}
                          onChange={(date) => {
                            setValue("date", date);
                            onDateChange(date);
                          }}
                          value={date}
                          calendarIcon={
                            <img src={calendarIcon} alt="calender" />
                          }
                        />
                      </>
                    );
                  }}
                />
              </FormControl>
              <FormControl fullWidth style={{ marginBottom: "24px" }}>
                <Controller
                  name="program"
                  control={control}
                  rules={{ required: true }}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <KenSelect
                        name="program"
                        required
                        select
                        label="Academic Programs"
                        value={program}
                        labelClassName={classes.inputFieldLabel}
                        options={[
                          { label: "Program 1", value: "1" },
                          { label: "Program 2", value: "2" },
                        ]}
                        {...field}
                        error={error}
                        onChange={(event, item, v) => {
                          setProgram(event.target.value);
                          setValue("program", event.target.value);
                        }}
                      />
                    );
                  }}
                />
              </FormControl> */}
                  <Box width="100%">
                    <KenButton
                      variant="roundedButton"
                      buttonClass={classes.verify}
                      type="submit"
                      disabled={loading}
                    >
                      Verify
                    </KenButton>
                    {loading && (
                      <CircularProgress
                        size={24}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '49%',
                          transform: 'translate(-50%, -50%)',
                        }}
                      />
                    )}
                  </Box>
                  <Box
                    display={'flex'}
                    justifyContent="center"
                    alignItems={'center'}
                    width="100%"
                  >
                    <AccountLink
                      text="Already Have An Account?"
                      actionText={'Login'}
                      onAction={() =>
                        prog
                          ? navigate(`${routes.login}?prog=${prog}`)
                          : navigate(routes.login)
                      }
                    />
                  </Box>
                </PerfectScrollbar>
              </Box>
            </form>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
